// extracted by mini-css-extract-plugin
module.exports = {"Cocktail":"Cocktail_Cocktail__3vZvx","Title":"Cocktail_Title__3iavb","Img":"Cocktail_Img__3I6Ki","ArrowBack":"Cocktail_ArrowBack__3BGUW"};